import React from 'react';


export function TableBody({ getTableBodyProps, rows, prepareRow }) {

    return (
        <tbody {...getTableBodyProps()}>

            {rows.map(
                (row, i) => {
                    prepareRow(row);
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                if (typeof cell.value === 'boolean') {
                                    return <td {...cell.getCellProps({ className: cell.column.className })} key={row.index + '.' + cell.column.id}>{cell.value.toString()}</td>
                                } else {
                                    return (
                                        <td {...cell.getCellProps({ className: cell.column.className })} key={row.index + '.' + cell.column.id}>{cell.render('Cell')}</td>
                                    )
                                }
                            })}
                        </tr>
                    )
                }
            )}
        </tbody>
    )
}